import SideMenu from '@/containers/side-menu/SideMenu.vue'
import AnalyticDailyPdv from '@/pages/reports/analytic-daily-pdv/AnalyticDailyPdv.vue'
import AnalyticMonthlyPdv from '@/pages/reports/analytic-monthly-pdv/AnalyticMonthlyPdv.vue'

import AnalyticDailyCabine from '@/pages/reports/analytic-daily-cabine/AnalyticDailyCabine.vue'
import AnalyticMonthlyCabine from '@/pages/reports/analytic-monthly-cabine/AnalyticMonthlyCabine.vue'

import AnalyticDailyAgent from '@/pages/reports/analytic-daily-agent/AnalyticDailyAgent.vue'
import AnalyticMonthlyAgent from '@/pages/reports/analytic-monthly-agent/AnalyticMonthlyAgent.vue'

import AnalyticDailyParkingmeter from '@/pages/reports/analytic-daily-parkingmeter/AnalyticDailyParkingmeter.vue'
import AnalyticMonthlyParkingmeter from '@/pages/reports/analytic-monthly-parkingmeter/AnalyticMonthlyParkingmeter.vue'

export default [
  {
    path: '/analytic/daily/pdv',
    name: 'AnalyticDailyPdv',
    components: {
      mainContent: AnalyticDailyPdv,
      mainMenu: SideMenu,
    },
    meta: {
      role: {
        sectorId: 'report-daily-sales-pdv',
      },
      breadcrumb: {
        title: 'Relatório Analítico Diário do PDV',
        paths: [{ title: 'Relatório Analítico Diário do PDV' }],
      },
    },
  },
  {
    path: '/analytic/monthly/pdv',
    name: 'AnalyticMonthlyPdv',
    components: {
      mainContent: AnalyticMonthlyPdv,
      mainMenu: SideMenu,
    },
    meta: {
      role: {
        sectorId: 'report-monthly-sales-pdv',
      },
      breadcrumb: {
        title: 'Relatório Analítico Mensal do PDV',
        paths: [{ title: 'Relatório Analítico Mensal do PDV' }],
      },
    },
  },
  // Cabine
  {
    path: '/analytic/daily/cabine',
    name: 'AnalyticDailyCabine',
    components: {
      mainContent: AnalyticDailyCabine,
      mainMenu: SideMenu,
    },
    meta: {
      role: {
        sectorId: 'report-daily-sales-cabine',
      },
      breadcrumb: {
        title: 'Relatório Analítico Diário da Cabine',
        paths: [{ title: 'Relatório Analítico Diário da Cabine' }],
      },
    },
  },
  {
    path: '/analytic/monthly/cabine',
    name: 'AnalyticMonthlyCabine',
    components: {
      mainContent: AnalyticMonthlyCabine,
      mainMenu: SideMenu,
    },
    meta: {
      role: {
        sectorId: 'report-monthly-sales-cabine',
      },
      breadcrumb: {
        title: 'Relatório Analítico Mensal da Cabine',
        paths: [{ title: 'Relatório Analítico Mensal da Cabine' }],
      },
    },
  },
  // Agent
  {
    path: '/analytic/daily/agent',
    name: 'AnalyticDailyAgent',
    components: {
      mainContent: AnalyticDailyAgent,
      mainMenu: SideMenu,
    },
    meta: {
      role: {
        sectorId: 'report-daily-sales-agent',
      },
      breadcrumb: {
        title: 'Relatório Analítico Diário do Agente',
        paths: [{ title: 'Relatório Analítico Diário do Agente' }],
      },
    },
  },
  {
    path: '/analytic/monthly/agent',
    name: 'AnalyticMonthlyAgent',
    components: {
      mainContent: AnalyticMonthlyAgent,
      mainMenu: SideMenu,
    },
    meta: {
      role: {
        sectorId: 'report-monthly-sales-agent',
      },
      breadcrumb: {
        title: 'Relatório Analítico Mensal do Agente',
        paths: [{ title: 'Relatório Analítico Mensal do Agente' }],
      },
    },
  },
  // Parkingmeter
  {
    path: '/analytic/daily/parkingmeter',
    name: 'AnalyticDailyParkingmeter',
    components: {
      mainContent: AnalyticDailyParkingmeter,
      mainMenu: SideMenu,
    },
    meta: {
      role: {
        sectorId: 'report-daily-sales-parking-meter',
      },
      breadcrumb: {
        title: 'Relatório Analítico Diário do Parquímetro',
        paths: [{ title: 'Relatório Analítico Diário do Parquímetro' }],
      },
    },
  },
  {
    path: '/analytic/monthly/parkingmeter',
    name: 'AnalyticMonthlyParkingmeter',
    components: {
      mainContent: AnalyticMonthlyParkingmeter,
      mainMenu: SideMenu,
    },
    meta: {
      role: {
        sectorId: 'report-monthly-sales-parking-meter',
      },
      breadcrumb: {
        title: 'Relatório Analítico Mensal do Parquímetro',
        paths: [{ title: 'Relatório Analítico Mensal do Parquímetro' }],
      },
    },
  },
]